import { AUTH_ROUTE_NAME } from "@/libs/route-name";

export const signupRoute = () => {
  return {
    name: AUTH_ROUTE_NAME.SIGNUP,
    path: "signup",
    component: () => import("@/pages/auth/signup.vue"),
    meta: { onlyGuest: true }
  };
};
